export const SwitchViewActionTypes = {
  SELECT_VIEW: '[switchView] SELECT_VIEW',
  SET_DISABLED: '[switchView] SET_DISABLED',
};

export type SWITCH_VIEW_TYPE =
  | 'QUESTION_VIEW'
  | 'LIST_VIEW'

export function isSWITCH_VIEW_TYPE(str: string): str is SWITCH_VIEW_TYPE {
  return (
    str === 'QUESTION_VIEW' ||
        str === 'LIST_VIEW'
  );
}

export const LIST_VIEW: SWITCH_VIEW_TYPE = 'LIST_VIEW';
export const QUESTION_VIEW: SWITCH_VIEW_TYPE = 'QUESTION_VIEW';